




































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import {
  MultipleRecurrenceFrequencyOptions,
  RecurrenceSettingPayload,
  DataCollectionPeriodDTO,
  DataCollectionPeriodSettingsPayload,
} from '@/store/modules/projects/types/projects.types';
import { StringInputOption } from '@/jbi-shared/types/form.types';
import AuditCycleDataSetup from './AuditCycleDataSetup.vue';
import ProjectCreationMultipleDatePicker from './ProjectCreationMultipleDatepicker.vue';
import moment from 'moment';
import { getStartDateTime, getEndDateTime } from '../../../utils/date.util';
import { cloneData } from '@/utils/general.util';
import {
  AuditSamplingType,
  MultipleRecurrenceType,
  RecurrenceType,
} from '@/jbi-shared/types/project.types';
import { AuditSamplingTypeDisplayOptions } from '@/store/modules/audits/types/audits.types';
import { Action, State } from 'vuex-class';
const dirtyMonths = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];

@Component({
  components: {
    ProjectCreationMultipleDatePicker,
    AuditCycleDataSetup,
  },
})
export default class RecurrenceSettings extends Vue {
  @Prop() public deactivate!: boolean;
  @Prop({ type: Array, default: () => [] })
  public projectCriteria!: Array<{
    title: string;
    uniqueCriteriaId: string | number;
  }>;
  @Prop({ type: Array, default: () => [] })
  public projectSites!: Array<{ id: number; name: string }>;
  @Prop({ type: Array, default: () => [] })
  public projectDataCollectors!: Array<{
    email: string;
    siteIds: number[];
  }>;

  @Action('projects/saveProjectSettingFormData')
  public saveProjectSettingFormData!: (
    payload: RecurrenceSettingPayload | undefined,
  ) => void;

  @State((state) => state.projects.projectSettingForm)
  public projectSettingForm!: RecurrenceSettingPayload;

  public minStartDate: Date = new Date(
    new Date().setDate(new Date().getDate() - 1),
  );
  public defaultEndDate: moment.Moment = moment(new Date()).add(1, 'M');
  public dataCollectionPeriodKey: number = Math.floor(Math.random() * 999);
  public showIntervalError: boolean = false; // Error msg for validating input duration of recurrence cycles(Data Collection Period/Audit)
  public showTotalError: boolean = false; // Error msg for validating input number of Recurrence Cycles(Data Collection Period/Audit)
  public isFormDataValid: boolean = false;

  get recurrenceSetting() {
    /** if projectSettingForm exists use projectSettingForm else set default values */
    if (this.projectSettingForm) {
      return this.projectSettingForm;
    } else {
      const recurrenceSetting: RecurrenceSettingPayload = {
        recurrenceType: RecurrenceType.ONE_OFF,
        multipleRecurrenceType: null,
        auditSamplingType: AuditSamplingType.TARGET_SAMPLE_SIZE,
        interval: 1,
        auditNumber: 1,
        scheduledRecurrenceStartDate: new Date(),
        scheduledRecurrenceEndDate: null,
        enableGrip: true,
        dataCollectionPeriodSettings: {
          0: {
            auditNumber: 1,
            auditName: 'Baseline',
            startDate: new Date(),
            endDate: this.defaultEndDate.subtract(1, 'd').toDate(),
            auditCriteriaIds: this.projectCriteria.map(
              (pc) => pc.uniqueCriteriaId,
            ),
            auditSiteIds: this.projectSites.map((ps) => ps.id),
            auditParticipants: cloneData(this.projectDataCollectors),
          },
        },
      };

      return recurrenceSetting;
    }
  }

  public emitChanges(payload: RecurrenceSettingPayload) {
    this.isFormDataValid = Object.keys(
      payload.dataCollectionPeriodSettings,
    ).every(
      (key: any) =>
        payload.dataCollectionPeriodSettings[key].auditCriteriaIds.length > 0 &&
        payload.dataCollectionPeriodSettings[key].auditSiteIds.length > 0,
    );
    this.$emit('updateRecurrenceSetting', payload);
    this.saveProjectSettingFormData(payload);
    this.$emit('updateIsFormDataValid', this.isFormDataValid);
  }

  syncData() {
    const settings: RecurrenceSettingPayload = cloneData(
      this.projectSettingForm,
    );

    const projectCriteriaIds = this.projectCriteria.map(
      (pc) => pc.uniqueCriteriaId,
    );
    const projectSitesIds = this.projectSites.map((ps) => ps.id);
    const dataCollectionPeriods: DataCollectionPeriodSettingsPayload = {};

    Object.keys(settings.dataCollectionPeriodSettings).map((key: any) => {
      const tempSettings: DataCollectionPeriodDTO = cloneData(
        settings.dataCollectionPeriodSettings[key],
      );

      const auditCriteriaIds = tempSettings.auditCriteriaIds.filter((ac: any) =>
        projectCriteriaIds.includes(ac),
      );

      const auditSiteIds = tempSettings.auditSiteIds.filter((as) =>
        projectSitesIds.includes(as),
      );
      const auditParticipants: {
        email: string;
        siteIds: number[];
      }[] = [];
      tempSettings.auditParticipants.forEach((ap) => {
        const user = this.projectDataCollectors.find(
          (pdc) => pdc.email === ap.email,
        );

        if (user) {
          const sites = user.siteIds.filter((siteId) =>
            tempSettings.auditSiteIds.includes(siteId),
          );

          if (sites.length > 0) {
            auditParticipants.push({ ...user, siteIds: sites });
          }
        }
      });

      const data: DataCollectionPeriodDTO = {
        auditNumber: tempSettings.auditNumber,
        auditName: tempSettings.auditName,
        startDate: tempSettings.startDate,
        endDate: tempSettings.endDate,
        auditSiteIds,
        auditCriteriaIds,
        auditParticipants,
      };

      dataCollectionPeriods[key] = data;
    });

    this.saveProjectSettingFormData({
      ...settings,
      dataCollectionPeriodSettings: dataCollectionPeriods,
    });
  }

  public getSelectedAuditCriteriaIds(index: number): Array<string | number> {
    if (this.recurrenceSetting.dataCollectionPeriodSettings[index]) {
      return this.recurrenceSetting.dataCollectionPeriodSettings[index]
        .auditCriteriaIds;
    }
    return [];
  }

  public getSelectedAuditSiteIds(index: number): number[] {
    if (this.recurrenceSetting.dataCollectionPeriodSettings[index]) {
      return this.recurrenceSetting.dataCollectionPeriodSettings[index]
        .auditSiteIds;
    }
    return [];
  }

  public getSelectedAuditParticipantsIds(index: number): string[] {
    if (this.recurrenceSetting.dataCollectionPeriodSettings[index]) {
      return this.recurrenceSetting.dataCollectionPeriodSettings[
        index
      ].auditParticipants.map((ap) => ap.email);
    }

    return [];
  }

  get RecurrenceType(): typeof RecurrenceType {
    return RecurrenceType;
  }

  get AuditSamplingType(): typeof AuditSamplingType {
    return AuditSamplingType;
  }

  get auditSamplingTypeDisplayOptions() {
    return AuditSamplingTypeDisplayOptions;
  }

  get selectedSamplingType(): AuditSamplingType {
    return this.recurrenceSetting.auditSamplingType;
  }

  set selectedSamplingType(newValue) {
    const temp = cloneData(this.recurrenceSetting);
    temp.auditSamplingType = newValue;
    this.dataCollectionPeriodKey += 1;
    this.emitChanges(temp);
  }

  get selectedRecurrenceType(): RecurrenceType {
    return this.recurrenceSetting.recurrenceType;
  }

  set selectedRecurrenceType(newValue) {
    const temp = cloneData(this.recurrenceSetting);
    temp.recurrenceType = newValue;
    temp.auditNumber = 1;
    temp.interval = 1;
    temp.multipleRecurrenceType =
      newValue === RecurrenceType.MULTIPLE
        ? MultipleRecurrenceType.MONTHLY
        : null;

    if (newValue === RecurrenceType.MULTIPLE) {
      this.updateTotalDataCollectionPeriod();
    }
    this.emitChanges(temp);
  }

  get scheduledRecurrenceStartDate() {
    const recurrenceStartDate: any = this.recurrenceSetting
      .scheduledRecurrenceStartDate;
    return recurrenceStartDate !== undefined && recurrenceStartDate
      ? getStartDateTime(recurrenceStartDate)
      : getStartDateTime();
  }

  set scheduledRecurrenceStartDate(newValue) {
    const temp = cloneData(this.recurrenceSetting);
    temp.scheduledRecurrenceStartDate = newValue;
    this.dataCollectionPeriodKey += 1;
    this.emitChanges(temp);
  }

  get dataCollectionPeriods() {
    return this.recurrenceSetting.dataCollectionPeriodSettings
      ? this.recurrenceSetting.dataCollectionPeriodSettings
      : this.updateTotalDataCollectionPeriod();
  }

  get multipleRecurrenceFrequencyOptions(): StringInputOption[] {
    return Object.entries(MultipleRecurrenceFrequencyOptions).map(
      ([key, value]) => {
        return {
          id: key,
          name: value,
        };
      },
    );
  }

  get multipleRecurrenceType(): MultipleRecurrenceType {
    return this.recurrenceSetting.multipleRecurrenceType !== undefined &&
      this.recurrenceSetting.multipleRecurrenceType
      ? this.recurrenceSetting.multipleRecurrenceType
      : MultipleRecurrenceType.MONTHLY;
  }

  set multipleRecurrenceType(newValue) {
    const temp = cloneData(this.recurrenceSetting);
    temp.multipleRecurrenceType = newValue;
    this.dataCollectionPeriodKey += 1;
    this.emitChanges(temp);
  }

  get interval(): number {
    return this.recurrenceSetting.interval
      ? this.recurrenceSetting.interval
      : 0;
  }

  set interval(newValue: number) {
    const temp = cloneData(this.recurrenceSetting);
    temp.interval = newValue;
    this.showIntervalError = !newValue || newValue < 1 ? true : false;
    this.dataCollectionPeriodKey += 1;
    this.emitChanges(temp);
  }

  get auditNumber(): number {
    return this.recurrenceSetting.auditNumber
      ? this.recurrenceSetting.auditNumber
      : 0;
  }

  set auditNumber(newValue: number) {
    const temp = cloneData(this.recurrenceSetting);
    temp.auditNumber = newValue;
    this.showTotalError = newValue < 1 || newValue > 10;
    this.dataCollectionPeriodKey += 1;
    this.emitChanges(temp);
  }

  /** Returns title and description for each recurrence type, used for display purposes  */
  public recurrenceTypeDisplayInfo(
    type: RecurrenceType,
  ): {
    title: string;
    infotext1: string;
    infotext2: string | undefined;
  } {
    switch (type) {
      case RecurrenceType.ONE_OFF:
        return {
          title: 'One-off',
          infotext1:
            'Create a one off project for a specified data collection period.',
          infotext2:
            '(You can add subsequent data collection periods at a later date if required)',
        };
      case RecurrenceType.ONGOING:
        return {
          title: 'Ongoing',
          infotext1:
            'Create an ongoing project where data collection happens continuously over weeks, months or years.',
          infotext2: undefined,
        };
      case RecurrenceType.MULTIPLE:
        return {
          title: 'Multiple Data Collection Periods',
          infotext1:
            'Create multiple data collection periods such as for a pre-test post-test study, as part of an audit and feedback (and audit) project, or quality improvement cycles.',
          infotext2: undefined,
        };
      default:
        return {
          title: '',
          infotext1: '',
          infotext2: '',
        };
    }
  }

  /**
   * Handles assigning auditCriteriaIds, auditSiteIds, and auditParticipants to the selected index,
   * then emits the updated data to the parent component to reflect the changes
   */
  public handleUpdatedCycleData(
    data: {
      auditCriteriaIds: (string | number)[];
      auditSiteIds: number[];
      auditParticipants: { email: string; siteIds: number[] }[];
    },
    index: number,
  ) {
    const temp = cloneData(this.recurrenceSetting);

    // Store the selected data in the recurrence settings
    temp.dataCollectionPeriodSettings[index].auditCriteriaIds =
      data.auditCriteriaIds;
    temp.dataCollectionPeriodSettings[index].auditSiteIds = data.auditSiteIds;
    temp.dataCollectionPeriodSettings[index].auditParticipants =
      data.auditParticipants;

    // Emit update to parent
    this.emitChanges(temp);
  }

  public getDate(newValue: Date): string {
    return (
      newValue.getDate() +
      ' ' +
      dirtyMonths[newValue.getMonth()] +
      ' ' +
      newValue.getFullYear()
    );
  }

  public formatDateRange(date: Date): string {
    return this.getDate(date);
  }

  public updateDataCollectionPeriodInitialSettings(newValue: {
    auditName: string;
    auditNumber: number;
    startDate: Date;
    endDate: Date;
  }) {
    const tempUpdatedSettings = {
      ...this.recurrenceSetting,
    };

    tempUpdatedSettings.dataCollectionPeriodSettings[newValue.auditNumber] = {
      ...tempUpdatedSettings.dataCollectionPeriodSettings[newValue.auditNumber],
      ...newValue,
    };

    this.emitChanges(tempUpdatedSettings);
  }

  /**
   * Updates initial settings for the selectedRecurrenceType 'MULTIPLE'.
   *
   * When the user selects the number of recurrence cycles,
   * this function generates and initializes the default data structure for each cycle.
   */
  public updateTotalDataCollectionPeriod() {
    const dataCollectionPeriodSettings = [];
    const scheduledStartDate = moment(this.scheduledRecurrenceStartDate);
    if (this.selectedRecurrenceType !== RecurrenceType.MULTIPLE) {
      dataCollectionPeriodSettings.push({
        startDate: getStartDateTime(scheduledStartDate),
        endDate: null,
        auditNumber: 1,
        auditName: 'Baseline',
        auditCriteriaIds: this.projectCriteria.map((pc) => pc.uniqueCriteriaId),
        auditSiteIds: this.projectSites.map((ps) => ps.id),
        auditParticipants: cloneData(this.projectDataCollectors),
      });
    } else {
      const intervalValue = this.interval;
      let auditNumberValue = this.auditNumber;

      /** Reset auditNumberValue to 1 if it exceeds 10, and exit early to prevent further processing */
      if (auditNumberValue > 10) {
        auditNumberValue = 1;
        return;
      }

      for (let value = 0; value < auditNumberValue; value++) {
        const startDate =
          value > 0
            ? scheduledStartDate.add(1, 'd').toDate()
            : scheduledStartDate.toDate();

        const newAuditName = value > 0 ? `Follow Up ${value}` : 'Baseline';
        switch (this.multipleRecurrenceType) {
          case Object.keys(MultipleRecurrenceFrequencyOptions)[0]:
            scheduledStartDate.add(intervalValue, 'd');
            break;
          case Object.keys(MultipleRecurrenceFrequencyOptions)[1]:
            scheduledStartDate.add(intervalValue, 'w');
            break;
          case Object.keys(MultipleRecurrenceFrequencyOptions)[2]:
            scheduledStartDate.add(intervalValue, 'M');
            break;
          default:
            scheduledStartDate.add(intervalValue, 'y');
            break;
        }
        const newEndDate: Date = scheduledStartDate.subtract(1, 'd').toDate();
        const dateRangePeriod: Date[] = [startDate, newEndDate];
        dataCollectionPeriodSettings.push({
          startDate: getStartDateTime(dateRangePeriod[0]),
          endDate: getEndDateTime(dateRangePeriod[1]),
          auditNumber: value + 1,
          auditName: newAuditName,
          auditCriteriaIds: this.projectCriteria.map(
            (pc) => pc.uniqueCriteriaId,
          ),
          auditSiteIds: this.projectSites.map((ps) => ps.id),
          auditParticipants: cloneData(this.projectDataCollectors),
        });
      }
    }

    const multipleAuditCyclesData: DataCollectionPeriodSettingsPayload = {
      ...dataCollectionPeriodSettings,
    };
    const temp = cloneData(this.recurrenceSetting);
    temp.dataCollectionPeriodSettings = multipleAuditCyclesData;
    this.emitChanges(temp);
    return multipleAuditCyclesData;
  }
}
